import React, { useState } from 'react';
import axios from 'axios';  // We'll use axios to send the POST request
import contactImage from '../../assets/contact.jpeg'; // adjust path if needed
import mandala from '../../assets/wallpaper.png';
import Footer from '../../components/Footer';
import ScrollToHashElement from '../ScrollToHashElement'; // 👈 Import here

const Contactpage = () => {

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    contactNumber: '',
    email: '',
    city: '',
    purpose: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
     setLoading(true); // disable the button

    try {
      const response = await axios.post('/api/contact', formData);
      // console.log('New contact saved:', newContact);  // Debugging log
      alert('Form submitted successfully!');
      setFormData({
        name: '',
        contactNumber: '',
        email: '',
        city: '',
        purpose: '',
        message: '',
      });  // Reset form after submission
    } catch (error) {
      console.error('Error submitting the form', error);
      alert('Error submitting the form. Please try again.');
    }
    finally {
    setLoading(false); // re-enable the button
  }
  };

 return (
  <>
    <div id='contact' className="w-full bg-white py-16 max-[440px]:pt-8 flex justify-center relative overflow-x-hidden">
      <ScrollToHashElement/>
      <div className="hidden sm:block">
        <img
          src={mandala}
          alt="Mandala Top Right"
          className="absolute top-[-200px] right-[-220px] w-[500px] opacity-[0.7] z-0"
        />
        <img
          src={mandala}
          alt="Mandala Top Left"
          className="absolute top-[-200px] left-[-220px] w-[500px] opacity-[0.7] z-0"
        />
      </div>
      <div className="w-full flex flex-col items-center px-[40px] max-[440px]:px-4">
        {/* Heading */}
        <h2 className="text-[32px] font-bold text-[#AD2F3B] mt-[30px] mb-[100px] border-b-2 border-[#AD2F3B] leading-[55px] 
  max-[440px]:mt-[0px] max-[440px]:text-[20px] max-[440px]:mb-8 max-[440px]:leading-[30px]">
  GET IN TOUCH
</h2>


        {/* Content: Image + Form */}
        <div className="w-full flex flex-col md:flex-row md:items-start gap-12">
          {/* Image - Only change padding in mobile */}
          <div className="flex-shrink-0 mx-auto max-[440px]:w-full max-[440px]:px-4">
            <img
              src={contactImage}
              alt="Contact"
              className="w-[620px] h-[650px] object-cover rounded-md max-[440px]:w-full max-[440px]:h-[350px]"
            />
          </div>

          {/* Form - Only adjust mobile padding and width */}
          <div className="flex-1 mt-[9px] max-[440px]:w-full max-[440px]:px-4">
            <form 
              className="grid grid-cols-1 md:grid-cols-2 gap-10 max-[440px]:gap-6 max-[440px]:mt-[-30px]"
              onSubmit={handleSubmit}
            >
              {/* Name */}
              <div>
                <label className="text-[#AD2F3B] font-semibold block mb-2 text-[19px] max-[440px]:text-[14px]">
                  Name:
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter Name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 outline-none text-[18px] max-[440px]:w-full placeholder:text-[18px] max-[440px]:text-[12px] max-[440px]:placeholder:text-[12px]"
                />
              </div>

              {/* Contact Number */}
              <div>
                <label className="text-[#AD2F3B] font-semibold block mb-2 text-[19px] max-[440px]:text-[14px]">
                  Contact number:
                </label>
                <input
                  type="text"
                  name="contactNumber"
                  placeholder="Enter Contact No."
                  value={formData.contactNumber}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 max-[440px]:w-full outline-none text-[18px] placeholder:text-[18px] max-[440px]:text-[12px] max-[440px]:placeholder:text-[12px]"
                />
              </div>

              {/* Email */}
              <div>
                <label className="text-[#AD2F3B] font-semibold block mb-2 text-[19px] max-[440px]:text-[14px]">
                  Email ID:
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter Email ID"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 outline-none text-[18px] placeholder:text-[18px] max-[440px]:text-[12px] max-[440px]:placeholder:text-[12px]"
                />
              </div>

              {/* City */}
              <div>
                <label className="text-[#AD2F3B] font-semibold block mb-2 text-[19px] max-[440px]:text-[14px]">
                  City:
                </label>
                <input
                  type="text"
                  name="city"
                  placeholder="Enter City"
                  value={formData.city}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 outline-none text-[18px] placeholder:text-[18px] max-[440px]:text-[12px] max-[440px]:placeholder:text-[12px]"
                />
              </div>

              {/* Purpose */}
              <div className="md:col-span-2">
                <label className="text-[#AD2F3B] font-semibold block mb-2 text-[19px] max-[440px]:text-[14px]">
                  Purpose:
                </label>
                <div className="relative w-full">
                  <select
                    name="purpose"
                    value={formData.purpose}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg px-4 py-2 pr-10 outline-none text-[18px] appearance-none text-gray-700 max-[440px]:text-[12px]"
                  >
                    <option value="">Select Purpose</option>
                    <option>Business Enquiry</option>
                    <option>General Enquiry</option>
                    <option>Media Enquiry</option>
                    <option>Work with us</option>
                    <option>Feedback</option>
                    <option>Volunteer</option>
                    <option>Internship</option>
                    <option>Other</option>
                  </select>
                </div>
              </div>

              {/* Message */}
              <div className="md:col-span-2">
                <label className="text-[#AD2F3B] font-semibold block mb-2 text-[19px] max-[440px]:text-[14px]">
                  Message:
                </label>
                <textarea
                  name="message"
                  placeholder="Enter your message here.."
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 h-[140px] resize-none outline-none text-[20px] placeholder:text-[18px] max-[440px]:text-[12px] max-[440px]:placeholder:text-[12px]"
                ></textarea>
              </div>

              {/* Submit Button */}
              <div className="w-full flex justify-center ml-[240px] mt-4 max-[440px]:ml-0">
                <button
                  type="submit"
                  className="px-10 max-[440px]:px-6  py-2  rounded-full border-2 border-[#AD2F3B] max-[440px]:text-[16px] text-[#AD2F3B] bg-white hover:text-white hover:!bg-[#AD2F3B] text-[18px]"
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  
    <Footer/>
    </>
  );
};

export default Contactpage;

